import React, { createContext, useContext, PropsWithChildren } from "react";
import type { Series } from "utils/charts/types";

export interface SeriesSelectionContextValue {
    selectedSeriesKeys: string[];
    setSelectedSeriesKeys: (keys: string[]) => void;
    availableSeries: Series[];
    registerAvailableSeries: (series: Series[]) => void;
}

const SeriesSelectionContext = createContext<SeriesSelectionContextValue | null>(null);

interface ProviderProps {
    value: SeriesSelectionContextValue;
}

export const SeriesSelectionProvider: React.FC<PropsWithChildren<ProviderProps>> = ({ value, children }) => (
    <SeriesSelectionContext.Provider value={value}>
        {children}
    </SeriesSelectionContext.Provider>
);

export const useSeriesSelection = () => useContext(SeriesSelectionContext);
